<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">企業級Agent中台</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企業級Agent中台</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">為企業量身打造生成式AI（GenAI）落地引擎：一站式解決選、練、用、管全流程難題。</p>
					<p style="font-size: 18px">提供完整的生成式AI（GenAI）工程化解決方案，無縫整合算力、模型、知識、應用四大核心要素，打造高效智能應用流水線，驅動企業數智化轉型。</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心模組</h2>
				<div class="product product-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">模型算力管理平台：高效駕馭算力資源</div>
									<div class="t2">
										異構融合，統一調度：兼容信創與非信創環境，支援多品牌CPU/GPU異構算力的統一納管與彈性調度。<br>
										算力優化，效能提升：基於模型特性與晶片類型，智能優化資源配置，顯著提升關鍵GPU等核心算力的利用率。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">企業私域知識管理平台：賦能模型精準認知</div>
									<div class="t2">
										知識提煉：高效解決企業專有數據向結構化知識的轉換（如向量化），構建專屬知識庫。<br>
										知識融合：為生成式AI提供豐富的企業背景知識，解決私域應用準確性問題。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">AI應用工程平台：加速場景應用構建</div>
									<div class="t2">
										開箱即用，模型豐富：提供40+主流基礎大模型一鍵調用，便於按需選型測試，快速驗證最佳實踐。<br>
										專屬精調，模型定制：提供完備的模型微調工具鏈，助力企業定制高精度專屬大模型。<br>
										敏捷組裝，應用無憂：解決場景化AI應用輕量化、模組化組裝難題，實現業務需求的快速落地。
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/agent1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">適用場景</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/agent2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能數據治理</div>
									<div class="t2">
										突破傳統局限：攻克企業長期面臨的挑戰——僅能處理結構化數據，海量非結構化數據因成本與效率問題沉睡未用。<br>
										釋放數據價值：實現對結構化與非結構化數據的統一治理，盤活全量數據資產，充分釋放企業大數據平台潛力。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">知識問答引擎</div>
									<div class="t2">專家級應答：基於專屬的企業私域知識庫訓練大模型應用，通過自然語言交流，精準理解、記憶與推理複雜業務問題，提供全面、準確的專業答案。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能文檔助手</div>
									<div class="t2">
										高效閱讀利器：支援文檔"一鍵智能摘要"，瞬間提煉核心綱要；支援通過自然對話，對文檔內容進行深度精讀和針對性提問。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">7x24 智能客服</div>
									<div class="t2">
										服務效率倍增：通過自然語言交互，全天候提供諮詢、業務辦理、信息查詢等服務。<br>
										用戶體驗升級：實現用戶需求秒級響應，顯著提升服務效率與客戶滿意度，同時有效減輕人工客服負擔。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能文案大師</div>
									<div class="t2">
										高效內容創作：內置豐富企業級經典文案模板。用戶僅需填充必要信息，即可快速生成符合企業規範、品質卓越的各類文案內容。
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
